<template>
  <div>
    <OpenOrdersModal
      :readOnly="true"
      :id="null"
      :valDeadlineWorkshopOverride="null"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Pedidos de stock</h2>
          <p>
            En este apartado se pueden gestionar los pedidos del taller
            correspondientes a stock.<br />Para ver los pedidos de taller
            correspondientes a ventas, ir a
            <b-link :to="{ name: 'AdminWorkshopOrdersScreen' }">Pedidos</b-link
            >.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de pedidos de stock</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminWorkshopStockOrdersEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nuevo pedido (stock)</b-button
                  >
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    v-b-modal.workshop-date-modal
                    ><b-icon icon="calendar-3" /> Calendario de
                    pedidos</b-button
                  > -->

                  <!-- <b-button
                    @click="refreshTable()"
                    class="ml-3"
                    variant="outline-primary"
                    ><b-icon icon="arrow-clockwise" /> Refrescar</b-button
                  > -->
                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:origin="props">
                  <span>{{
                    props.row.quote
                      ? 'Presupuesto #' +
                        props.row.quote.id +
                        ' (' +
                        props.row.quote.location_full.name_short +
                        ')'
                      : 'Stock'
                  }}</span>
                </template>

                <template v-slot:destination="props">
                  <!-- Recogida en tienda -->
                  <span
                    v-if="
                      props.row.quote &&
                      props.row.quote.shipping_method_full &&
                      [1, 2].includes(props.row.quote.shipping_method_full.id)
                    "
                    >{{ props.row.quote.shipping_method_full.name }}
                  </span>
                  <!-- Envío -->
                  <span
                    v-else-if="
                      props.row.quote &&
                      props.row.quote.shipping_method_full &&
                      ![1, 2].includes(props.row.quote.shipping_method_full.id)
                    "
                    >{{ props.row.quote.shipping_method_full.name }} ({{
                      props.row.quote.shipping_address_full.city
                    }}, {{ props.row.quote.shipping_address_full.country }})
                  </span>
                  <span v-else>-</span>
                </template>

                <template v-slot:in_delivery="props">
                  <span>{{
                    props.row.delivery
                      ? 'Albarán #' +
                        props.row.delivery.id +
                        ' (' +
                        props.row.delivery.location_full.name_short +
                        ')'
                      : '-'
                  }}</span>
                </template>

                <template v-slot:abbr_product_names="props">
                  <div
                    :key="i"
                    v-for="(abbr_product_name, i) in props.row
                      .abbr_product_names"
                  >
                    {{
                      abbr_product_name['qty'] +
                      ' x ' +
                      abbr_product_name['name']
                    }}
                    <!-- ({{ props.row.product_status[i] | formatStatus }}) -->
                  </div>
                </template>

                <template v-slot:product_status="props">
                  <div
                    :key="i"
                    v-for="(product_status, i) in props.row.product_status"
                  >
                    {{ product_status | formatStatus }}
                  </div>
                </template>

                <template v-slot:product_deliveries="props">
                  <div
                    :key="i"
                    v-for="(product_deliveries, i) in props.row
                      .product_deliveries"
                  >
                    <b-link
                      v-if="product_deliveries >= 0"
                      :to="{
                        name: 'AdminDeliveriesEditScreen',
                        params: { id: product_deliveries },
                      }"
                    >
                      {{ product_deliveries }}
                    </b-link>
                    <span v-else>-</span>
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:status="props">
                  <span>{{ props.row.status | formatStatus }}</span>
                </template>

                <template v-slot:quote_id="props">
                  <div
                    v-if="
                      props.row.workshoporderstatushistory_set.length === 1 &&
                      props.row.workshoporderstatushistory_set[0].status ===
                        'Delivered'
                    "
                  >
                    Venta en tienda (<b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >)
                  </div>
                  <div v-else-if="props.row.quote_id">
                    <b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >
                  </div>
                  <div v-else>Venta web</div>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminWorkshopStockOrdersEditScreen',
                      params: { id: props.row.id.toString() },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="pencil" aria-hidden="true" />
                  </b-button>

                  <!-- <b-button
                    @click="downloadOrder(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon
                      icon="file-earmark-arrow-down"
                      aria-hidden="true"
                    ></b-icon>
                    Pedido
                  </b-button> -->

                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <!-- <b-button
                      @click="
                        downloadWorkshopOrderLegal(props.row.id, props.row.invoice)
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                      ><b-icon
                        icon="file-earmark-check"
                        aria-hidden="true"
                      ></b-icon>
                      
                      Factura
                    </b-button> -->
                  </span>

                  <b-tooltip
                    v-if="
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                    "
                    :target="'btn-' + props.row.id"
                    triggers="hover"
                  >
                    {{
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                        ? 'Debe constar una dirección de facturación y esta debe contener un identificador de empresa/autónomo (CIF)'
                        : ''
                    }}
                  </b-tooltip>
                  <b-button
                    @click="downloadOrderWorkshop(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="gear-fill" aria-hidden="true"></b-icon> Orden
                  </b-button>

                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <b-button
                      @click="
                        downloadWorkshopOrderLegal(
                          props.row.id,
                          props.row.invoice
                        )
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                      ><b-icon
                        icon="file-earmark-check"
                        aria-hidden="true"
                      ></b-icon>
                      <!-- {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }} -->
                      Factura
                    </b-button>
                  </span>

                  <b-tooltip
                    v-if="
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                    "
                    :target="'btn-' + props.row.id"
                    triggers="hover"
                  >
                    {{
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                        ? 'Debe constar una dirección de facturación y esta debe contener un identificador de empresa/autónomo (CIF)'
                        : ''
                    }}
                  </b-tooltip>
                  <!-- <b-button
                    @click="removeOrder(props.row.id)"
                    :disabled="
                      props.row.status !== 'Received' ||
                      !!props.row.quote ||
                      !!props.row.delivery
                    "
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    ><b-icon icon="trash" aria-hidden="true" />
                  </b-button> -->
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';
import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminWorkshopStockOrdersScreen',
  props: {},
  components: { OpenOrdersModal },
  data() {
    return {
      table: {
        url: uris.workshopStockOrdersURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'abbr_product_names',
          'product_status',
          'product_deliveries',
          // 'employee_full_name',
          'total_price',
          // 'in_delivery',
          // 'destination',
          // 'status',
          // 'origin',
          'actions',
        ],
        options: {
          rowClassCallback: function (row) {
            return row.status === 'Received' ? 'bg-light-warning' : '';
          },
          sortable: ['modified_at', 'created_at'],
          headings: {
            origin: 'Origen',
            destination: 'Destino',
            in_delivery: 'En albarán',
            status: 'Estado',
            product_status: 'Estado',
            product_deliveries: 'En albarán',
            abbr_product_names: 'Productos',
            modified_at: 'Modificado',
            created_at: 'Creado',
            total_price: 'Total',
            id: '# Pedido',
            employee_full_name: 'Creado por',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    refreshTable() {
      this.$refs.table.refresh();
    },
    downloadOrder(id) {
      actions.downloadOrder(id).then((x) => {
        let fileName = 'Pedido.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    downloadWorkshopOrderLegal(id, invoiceID) {
      if (
        invoiceID ||
        (!invoiceID &&
          confirm(
            '¿Estás seguro que deseas generar una factura para el pedido ' +
              id +
              '?'
          ))
      ) {
        actions.downloadWorkshopOrderLegal(id).then((x) => {
          let fileName = 'Factura.pdf';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'application/pdf' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();

          //this.$refs.table.refresh();
        });
      }
      // uris.quoteDownloadURI(id);
    },
    downloadOrderWorkshop(id) {
      actions.downloadWorkshopOrderWorkshop(id).then((x) => {
        let fileName = 'Orden-taller.html';

        console.log();

        var winPrint = window.open(
          '',
          '',
          'left=0,top=0,width="100%",height="100%",toolbar=1,scrollbars=1,status=0'
        );
        winPrint['BASE_URL'] = process.env.VUE_APP_API_BASE_URL.replace(
          'api/',
          ''
        );
        winPrint.document.write(x.data);
        winPrint.document.close();
        // winPrint.print();
        winPrint.focus();

        // const contentDisposition = x.headers['content-disposition'];
        // if (contentDisposition) {
        //   const fileNameMatch = contentDisposition.match(/filename=(.+)/);
        //   if (fileNameMatch.length === 2) {
        //     fileName = fileNameMatch[1];
        //   }
        // }

        // let blob = new Blob([x.data], { type: 'application/pdf' });

        // let link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = fileName;
        // link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeOrder(x);
    //   });
    // },
    removeOrder(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el pedido de stock número ' +
            id +
            '?'
        )
      ) {
        actions.deleteWorkshopOrder(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .bg-light-warning {
  background-color: rgba(255, 255, 213, 0.55) !important;
  &:hover {
    color: #212529;
    background-color: rgba(255, 255, 213, 0.95) !important;
  }
}
</style>
